// multi-opening screens in the openings tables: a secondary opening fills a door slot on its
// primary opening's frame.

type ScreenSlotRow = {
    drwScreenPrimaryOpening?: number | null;
    drwScreenPrimaryOpeningName?: string | null;
    drwScreenSlot?: string | null;
};

export type ScreenSlotRef = {
    primaryOpening: number;
    slot: string;
};

// the Screen Elevation cell text of a secondary opening.
export function screenSlotLabel(row: ScreenSlotRow): string {
    if(!row.drwScreenPrimaryOpening) return "";
    return `${row.drwScreenPrimaryOpeningName || "#" + row.drwScreenPrimaryOpening} / ${row.drwScreenSlot || ""}`;
}

export function clearScreenSlot(row: ScreenSlotRow) {
    row.drwScreenPrimaryOpening = null;
    row.drwScreenPrimaryOpeningName = null;
    row.drwScreenSlot = null;
}

// the clipboard value for a secondary opening's Screen Elevation cell: the frame and slot it
// fills, or "" when it fills none.
export function screenSlotPayload(row: ScreenSlotRow): string {
    if(!row.drwScreenPrimaryOpening || !row.drwScreenSlot) return "";
    return JSON.stringify({__drwAdopt: "screenSlot", primaryOpening: row.drwScreenPrimaryOpening, slot: row.drwScreenSlot});
}

export function parseScreenSlotPayload(value: string): ScreenSlotRef | null {
    if(!value) return null;
    try {
        const o = JSON.parse(value);
        if(o?.__drwAdopt === "screenSlot" && typeof o.primaryOpening === "number" && typeof o.slot === "string") {
            return {primaryOpening: o.primaryOpening, slot: o.slot};
        }
    } catch {
        // not a screen slot payload
    }
    return null;
}
